import { createRouter, createWebHistory } from "vue-router";
import Game from "@/views/Game";
import Login from "@/views/Login";
import Invite from "@/views/Invite";
import Dev from "@/views/Dev";
import NotFound from "@/views/not-found";

const routes = [
	{
		path: "/",
		name: "Home",
		component: Login,
	},
	{
		path: "/game/:gameId?",
		name: "game",
		component: Game,
		props: route => ({
			gameId:
				route.params.gameId === ":gameId" || !route.params.gameId
					? "1234"
					: route.params.gameId,
		}),
	},
	{
		path: "/login",
		name: "login",
		component: Login,
	},
	{
		path: "/dev",
		name: "dev",
		component: Dev,
	},
	{
		path: "/invite/:gameId?",
		name: "invite",
		component: Invite,
		props: route => ({
			gameId:
				route.params.gameId === ":gameId" || !route.params.gameId
					? "1234"
					: route.params.gameId,
		}),
	},
	{
		path: "/:pathMatch(.*)*",
		name: "not-found",
		component: NotFound,
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

export default router;
